ready().then(function() {

    const createCustomTabs = () => {
        let bioTab = $('.biografie');
        let awards = $('.awards-section');

        bioTab.wrapInner('<span class="custom-tab-grid-item"></span>');

        let customTabGridItem = $('.custom-tab-grid-item');
        customTabGridItem.wrap('<div class="custom-tab-grid"></div>');

        let customTabGrid = $('.custom-tab-grid');
        customTabGrid.append('<span class="custom-tab-grid-item is-last-item"></span>');

        let customTabLastGridItem = $('.custom-tab-grid-item.is-last-item');
        customTabLastGridItem.append(awards);

        let toggleMore = $("<p class='toggle-more has-icon icon-arrow-down'></p>").text("Toon meer");
        awards.append(toggleMore);

        toggleMore.on('click',function() {
            awards.toggleClass('awards-open');
        });
    }

    const createCustomAuthorInfoSection = () => {
        let infoBio = $('.section-author-info .info-bio');
        let infoImg = $('.section-author-info .info-img-container img');

        infoBio.html('<p>Paul van Loon schrijft boeken voor kinderen van 7 tot 99 jaar. Dat doet hij al meer dan 35 jaar. Miljoenen kinderen in binnen- en buitenland kennen zijn boeken over Dolfje Weerwolfje, Foeksia de miniheks en over de Griezelbus. Zelf houdt hij het meest van griezelverhalen, gekke verhalen en grumorverhalen (dat is een combinatie van de eerste twee). De ideeën daarvoor haalt hij uit de Andere Werkelijkheid, die hij betreedt wanneer hij ’s nachts schrijft. </p>')
        infoImg.attr('src', '//kinderboeken.nl/wp-content/uploads/sites/52/2020/09/VK_Paul.jpg');
        $('<div class="photographer">© Tuffcat Media</div>').insertAfter(infoImg);
    }

    /**
     * We need to calculate the total width of the anchorslist and check that width with the current viewport width
     */

    const checkTotalWidthNavAnchors = () => {

        let anchorslist = $('main .nav-anchors-list'); // only the anchorslist in the main
        let navanchors = $('main .nav-anchors');
        let mainwidthanchorslist = 0;

        $(anchorslist).children().each(function () {
            mainwidthanchorslist += $(this).outerWidth(true); // include paddings and such
        });


        if(navanchors.width() <= mainwidthanchorslist) {
            navanchors.addClass('is-wider-then-vp') // is wider then viewport
            $("<div class='scroll-indicator-container'><span class='scroll-indicator scroll-indicator-left'></span><span class='scroll-indicator scroll-indicator-right'></span></div>").insertAfter(navanchors);
        }
    }

    /**
     * We need to add some custom css classes to be sure we place the right decoration images at the right components
     */

    const addCustomCssClasses = () => {

        let booklistcontainer = $('.section-book-list');
        let booklisttitle = booklistcontainer.find('.section-title');

        booklisttitle.each(function() {
            let cssclass = $(this).text().toLowerCase().split(/[ ]+/).join('-').slice(0, -1);
            $(this).closest('.section-book-list').addClass(cssclass);
        });
    }

    /**
     * We need to make the arrow icons on the main nav anchors clickable so that we can scroll them
     */

    const addClickableScrollIndicators = () => {
        const siright = $('main .section-nav-anchors .scroll-indicator-right');
        const sileft = $('main .section-nav-anchors .scroll-indicator-left');
        const a = $('main .nav-anchors.is-wider-then-vp');

        siright.on('click',function () {
            const scrollPos = a[0].scrollLeft;
            a.scrollLeft(scrollPos + 50);
        });

        sileft.on('click',function () {
            const scrollPos = a[0].scrollLeft;
            a.scrollLeft(scrollPos - 50);
        });
    }

    const showBookCoverInOrderSignedBookModal = () => {
        const bookSelect = $('select#input_81_1, select#input_81_32, select#input_81_37'); //GravityForms ID for the select element of the order signed book modal
        const bookSelectOneInputContainer = $('#field_81_1 .ginput_container');

        // Create image placeholder
        const placeholderImage = '//' + document.domain + '/wp-content/themes/kinderboeken/assets/images/placeholders/placeholder-book-cover.svg';
        const imageContainer = document.createElement('img');

        imageContainer.classList.add( 'img-container' );
        imageContainer.src = placeholderImage;

        bookSelectOneInputContainer.after(imageContainer);

        bookSelect.on('change', function(e) {
            // Define image URL and define target parent
            const coverImgUrl = bookSelect.find('option[value="' + e.currentTarget.value + '"]').data('cover-img');
            const imageTarget = e.currentTarget.closest('.ginput_container').parentElement;
            imageContainer.src = coverImgUrl;

            // Assign image to target element
            imageTarget.insertAdjacentElement('beforebegin', imageContainer);
            imageTarget.appendChild(imageContainer);
        });
    }

    /**
     *  Execute above functions
     */
    createCustomTabs();
    createCustomAuthorInfoSection();
    checkTotalWidthNavAnchors();
    addCustomCssClasses();
    addClickableScrollIndicators();
    showBookCoverInOrderSignedBookModal();
});
